




































import permissionGroup from '@/store/types/permissionGroup';
import newPermissionGroupForm from '@/components/Permissions/permissionForm.vue';
import { newPermissionGroupInterface } from '@/store/interfaces/PermissionGroup';
import { TeipNotifications } from '@/util/teipNotifications';
import { navLink } from '@/ts/navegationLinks';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewPermissionGroup',
  components: { newPermissionGroupForm, },
  data: () => ({
    kind: 0,
    navlink: [
      {
        name: 'Lista de grupo de permisos',
        active: false,
        to: '/permisos',
      },
      {
        name: 'Editar grupo de permisos',
        active: true,
      }
    ] as navLink[],
    isLoading: true,
    render: 1,
  }),
  computed: {
    ...mapGetters({
      getSinglePermissionGroup: `permissionGroupModule/${permissionGroup.getters.GET_SINGLE_PERMISSION_GROUP}`,
      getPermissionSectionList: `permissionGroupModule/${permissionGroup.getters.GET_PERMISSION_SECTION_LIST}`,
    }),
  },
  async mounted() {
    await this.singlePermissionGroup(this.$route.params.permission_id);
    const fetchPermissionFor = this.getSinglePermissionGroup.kind === 'staff' ? 0 : 1;
    this.$data.kind = fetchPermissionFor;
    await this.permissionSectionList(fetchPermissionFor);
    this.$data.isLoading = false;
  },
  methods: {
    ...mapActions({
      singlePermissionGroup: `permissionGroupModule/${permissionGroup.actions.SINGLE_PERMISSION_GROUP}`,
      permissionSectionList: `permissionGroupModule/${permissionGroup.actions.PERMISSION_SECTION_LIST}`,
      updatePermissionSectionList: `permissionGroupModule/${permissionGroup.actions.UPDATE_PERMISSION_GROUP}`,
    }),
    async kindGroup(kind: number) {
      this.$data.kind = kind;
      await this.permissionSectionList(kind);
    },
    updateGroup(model: newPermissionGroupInterface) {
      const notification = new TeipNotifications();
      model.kind = this.$data.kind === 1 ? 'companies' : 'staff';

      const dataToSend = {
        permission_id: this.$route.params.permission_id,
        data: model,
      };
      this.updatePermissionSectionList(dataToSend)
        .then(() => {
          notification.success('Permisos actualizados correctamente');
        })
        .catch(() => {
          notification.warning('Algo salió mal :( al tratar de actualizar');
        });
    },
  },
});
